'use strict';
var $ = require('jquery');
var ViewportTracker = require('../lib/ViewportTracker.js');
var AnimationEasing = require('../lib/AnimationEasing.js');
//var MobileLogger = require('./MobileLogger.js');

function init() {
	(function detectAndroidBrowser(html, userAgent) {
		if (/android\s(\d)/ig.test(userAgent) && !/(chrome|iemobile)/ig.test(userAgent)) {
			var versionOs = /[\d\.]+/.exec(/android\s[\d\.]*/ig.exec(userAgent));
			var versionBrowser = /[\d\.]+/.exec(/version\/.*\s/ig.exec(userAgent));
			html.addClass('android-os-' + versionOs).addClass('android-browser-' + versionBrowser);
		}
	})($('html'), navigator.userAgent);

	var animationUnsupported = $('html').hasClass('android-browser-4.0');
	
	//* for testing */MobileLogger.init();
	//* for testing */MobileLogger.log($('html').attr('class'));
	var config = {
		menu : '#menu',
		menuActive : false,
		menuCSS : 'hasMenuOpen',
		setupCSS : 'hasMenuSetup',
		subOpenedCSS : 'isOpen',
		subTarget : '.childWrap',
		subTrigger : '.hasChild > a',
		triggers : '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
		triggerEvent : 'click'
	};
	var $menu = $(config.menu);
	var $stateElem = $menu;
	var $subtarget = $menu.find(config.subTarget);

	function toggleMenu(event) {
		event.preventDefault();
		$stateElem.toggleClass(config.menuCSS);
	}
	function toggleSub(event) {
		event.preventDefault();
		var $target = $((event.target.tagName == 'SPAN') ? event.target.parentNode : event.target);
		$target.next().slideToggle((animationUnsupported ? 0 : 400), AnimationEasing.easeOutExpo);
		$target.parent('li').toggleClass(config.subOpenedCSS);
		//* for testing */MobileLogger.log(event.target.tagName + ' + .' + $target.next().get(0).className);
	}
	function begSub() {
		$stateElem.toggleClass(config.setupCSS);
		$subtarget.filter('.active').parents('li').addClass(config.subOpenedCSS);
		$subtarget.stop().slideUp().filter('.active').slideDown();
		//* for testing */MobileLogger.log($subtarget.get(0).tagName);
	}
	function endSub() {
		$stateElem.toggleClass(config.setupCSS);
		$subtarget.parents('li').removeClass(config.subOpenedCSS);
		$subtarget.stop().slideDown().attr('style', '');
	}
	function attachEventsWin() {
		if (config.menuActive === true) {
			return;
		}
		$(config.triggers).on(config.triggerEvent, toggleMenu);
		begSub();
		$menu.on('click.mobileMenu', config.subTrigger, toggleSub);
	}
	function detachEventsWin() {
		if (config.menuActive === false) {
			return;
		}
		$(config.triggers).off(config.triggerEvent, toggleMenu);
		endSub();
		$menu.off('click.mobileMenu');
	}
	function onViewportState() {
		var state = ViewportTracker.getState();
		$stateElem.removeClass(config.menuCSS);
		
		if (state == 'mobile') {
			attachEventsWin();
			config.menuActive = true;
		} else {
			detachEventsWin();
			config.menuActive = false;
		}
	}
	onViewportState();

	$(window).on('ViewportTracker:state', onViewportState);
}

module.exports = {
	init : init
};
